import { z } from 'zod';

export const LlmConfigSchema = z.object({
  llmUrl: z
    .string()
    .trim()
    .url('Invalid URL format')
    .min(1, 'URL cannot be empty')
    .nullable(),
  llmModelName: z
    .string()
    .trim()
    .min(1, 'Model name cannot be empty')
    .nullable(),
  llmAuthToken: z
    .string()
    .trim()
    .min(1, 'Bearer token cannot be empty')
    .nullable(),
});

export type ILlmConfigDto = z.infer<typeof LlmConfigSchema>;
